module.exports = __webpack_public_path__ + "media/audio27.a9f2b87c.mp3";